import { colors } from "../vars/palette";

export const buttonStyles = `
  padding: .5rem 1rem;
  border: 2px solid ${colors.hex("primary")};
  text-decoration: none;
  text-transform: uppercase;
  transform: scale(1);
  transition: all .3s ease;
  text-family: Rajdhani;
  font-weight: 600;
  :hover {
    transform: scale(1.1);
    transition: all .3s ease;
    background: white;
    color: ${colors.hex("primary")};
    border: 2px solid ${colors.hex("primary")};
  }
  :active, :focus {
    border: 2px solid ${colors.hex("primary")};
    background: none;
    transition: all .3s ease;
  }
`;
